import { useStore } from 'base/store';
import site from 'pro/config/site';
import { getUtmQuery, IUtmQuery } from 'base/utils/request';
import { useTrans } from 'base/utils/i18n'
import { ISharePopupInstance, useSharePopup } from '@base/lib/share/useSharePopup'

export type IUseShareLink = {
    url: string,
    title?: string,
    media?: any,
    utmQuery?: IUtmQuery,
    shareUrls?: ISharePopupInstance;
}

const getPropertyAttrMetas = () => {
    let metaNodeList = typeof document != 'undefined' ? document?.querySelectorAll("head meta[property]") : []
    const metas: any[] = []
    metaNodeList?.forEach((item) => {
        metas.push({
            property: item.getAttribute('property'),
            content: item.getAttribute('content') || ''
        })
    })
    return metas
}

export type IProps = {
    url?: string;
    utmQuery?: IUtmQuery;
    title?: string;
}

/**
 * 分享当前页面
 * @param props
 */
export function useShareLink(props?: IProps): IUseShareLink {

    const {
        url: urlProps,
        title: titleProps,
        utmQuery: utmQueryProps = {}
    } = props || {}

    const { t } = useTrans();

    const {
        rootStore: { state: { host, envName } },
        userStore: { state: { referralCode } },
    } = useStore();

    const utmQuery = getUtmQuery(referralCode, utmQueryProps);

    const metas = getPropertyAttrMetas()
    const ogImage = metas?.find((item) => item.property === 'og:image')
    const ogTitle = metas?.find((item) => item.property === 'og:title')
    const defaultTitle = t('web_share_msg_01', { brand: site.brand })

    let url = urlProps || `https://${envName !== 'dev' ? host : site.domain}`

    const shareUrls = useSharePopup({
        requireReferralCode: true,
        url: url,
        utmQuery: utmQuery
    });

    return {
        title: titleProps || ogTitle?.content || defaultTitle || '',
        url: url,
        utmQuery,
        media: ogImage?.content || '',
        shareUrls: shareUrls
    };
}